<div class="activity-log">
  @if (loading) {
    <div class="spinner-overlay">
      <mat-spinner class="spinner-center indu-spinner" diameter=50 mode="indeterminate">
      </mat-spinner>
    </div>
  }
  @if (logs.length == 0) {
    <div class="activity-empty">
      <mat-icon>history</mat-icon>
      <span>Sin registros</span>
    </div>
  }
  <div class="activity-table" [style.display]="logs.length > 0 ? 'block' : 'none'">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef> Fecha </th>
        <td mat-cell *matCellDef="let log" class="activity-date"> {{getDate(log.createdOn)}} </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Actividad </th>
        <td mat-cell *matCellDef="let log" class="activity-name"> {{log.name}} </td>
      </ng-container>
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef> Usuario </th>
        <td mat-cell *matCellDef="let log">
          <span class="activity-user">
            <span class="activity-avatar" aria-hidden="true">{{ initials(log.userName) }}</span>
            <span class="activity-user__name">{{log.userName}}</span>
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let log">
          @if (log.notes) {
            <mat-icon class="activity-chevron">
              {{log == expandedElement ? 'expand_less' : 'expand_more'}}
            </mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let log" [attr.colspan]="displayedColumns.length">
          <div class="log-detail" [@Expand-Collapse]="log == expandedElement ? 'expand' : 'collapse'">
            <div class="activity-notes">
              <span class="activity-notes__label">Notas</span>
              <p class="activity-notes__text">{{log.notes}}</p>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="log-row"
        [attr.tabindex]="element.notes ? 0 : null" [attr.aria-expanded]="element.notes ? expandedElement === element : null"
        [class.log-row--static]="!element.notes"
        [class.log-expanded-row]="expandedElement === element"
        (click)="toggle(element)"
        (keydown.enter)="toggle(element)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="log-detail-row"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Seleccionar página de registros"></mat-paginator>
  </div>
</div>
